// extracted by mini-css-extract-plugin
export default {"fieldGroup":"DW2zAy","title":"JqCdGF"};